module.exports = "<i>- Temporary blank placeholder page -</i>"